import React from 'react';
import { motion } from 'framer-motion';
export function CreatorQuote() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-dark border-y border-white/5" data-id="element-68">
      <div className="max-w-xl mx-auto text-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-70">
          <h3 className="text-sm font-bold text-brand-orange uppercase mb-5 tracking-widest" data-id="element-71">
            Über Swiss Peak System™
          </h3>

          <blockquote className="text-lg sm:text-xl font-medium text-brand-cream italic leading-relaxed mb-5" data-id="element-72">
            "Wir haben dieses System entwickelt, um das Skifahren in der Schweiz
            in einen Moment der puren Freiheit zu verwandeln — und dem Skifahrer
            die Last der Planung und der überhöhten Preise zu nehmen. Weniger
            Stress. Mehr Berge."
          </blockquote>

          <div className="font-black text-gray-400 text-sm" data-id="element-73">
            — Swiss Peak System™
          </div>
        </motion.div>
      </div>
    </section>;
}